import { render, staticRenderFns } from "./CadDadosEndereco.vue?vue&type=template&id=9fa2b66a&"
import script from "./CadDadosEndereco.vue?vue&type=script&lang=js&"
export * from "./CadDadosEndereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CadDadosEndereco.vue"
export default component.exports